// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"118":"ae6cac39","128":"d044bc50","130":"5f37290c","384":"8eadef26","460":"8abae27f","650":"0d97218e","686":"b370c7b2"}[chunkId] + ".js";
};